import React from 'react';

import { getStyle } from '../../utils/utils';
import { scaniaConnectionStyles as styles } from './scaniaConnectionStyles';

const HELP_ID = 'scania-api-credentials-help';

class ScaniaApiCredentialsHelp extends React.Component {
  constructor(props) {
    super(props);
    this.panel = React.createRef();
  }

  componentDidMount() {
    this.syncListeners();
    this.focusPanel();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.syncListeners();
      if (this.props.open) {
        this.focusPanel();
      }
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  syncListeners() {
    this.removeListeners();
    if (this.props.open) {
      document.addEventListener('mousedown', this.onDocumentMouseDown, true);
    }
  }

  removeListeners() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown, true);
  }

  focusPanel() {
    if (this.props.open && this.panel.current) {
      this.panel.current.focus();
    }
  }

  isInsideHelp(node) {
    if (this.panel.current && node && this.panel.current.contains(node)) {
      return true;
    }
    const { triggerEl } = this.props;
    return Boolean(triggerEl && node && triggerEl.contains(node));
  }

  onDocumentMouseDown = (event) => {
    if (!this.panel.current) {
      return;
    }
    if (this.isInsideHelp(event.target)) {
      return;
    }
    this.props.onDismiss();
  };

  onFocusOut = (event) => {
    const next = event.relatedTarget;
    if (!next || this.isInsideHelp(next)) {
      return;
    }
    this.props.onDismiss();
  };

  render() {
    const { open, t, screenSize, onClose } = this.props;
    if (!open) {
      return null;
    }
    return (
      <div
        id={HELP_ID}
        ref={this.panel}
        role="dialog"
        aria-modal="false"
        aria-label={t('helpTrigger')}
        tabIndex={-1}
        onBlur={this.onFocusOut}
        style={getStyle(screenSize, styles, 'helpPanel')}
      >
        <button
          type="button"
          aria-label={t('helpClose')}
          onClick={onClose}
          style={getStyle(screenSize, styles, 'helpClose')}
        >
          ×
        </button>
        <p style={getStyle(screenSize, styles, 'helpText')}>{t('helpCreateCredentials')}</p>
        <a
          href="https://developer.scania.com"
          target="_blank"
          rel="noopener noreferrer"
          style={getStyle(screenSize, styles, 'helpLink')}
        >
          {t('helpDeveloperPortal')}
        </a>
        <p style={getStyle(screenSize, styles, 'helpText')}>{t('helpAdminAccess')}</p>
        <a
          href="https://my.scania.com"
          target="_blank"
          rel="noopener noreferrer"
          style={getStyle(screenSize, styles, 'helpLink')}
        >
          {t('helpMyScania')}
        </a>
      </div>
    );
  }
}

export default ScaniaApiCredentialsHelp;
export { HELP_ID };
